import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { FooterBackgroundWrapper } from '@components/FooterBackgroundWrapper'
import { PriceExplanationDescription } from '@components/PriceInfo/PriceExplanationDescription'
import {
  getContactLink,
  getCopyright,
  getPersonalDataProcessingLink,
  getTermsAndConditionsLink,
} from '../helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import Container from './Container'
import styles from './Footer.module.scss'
import Typography from './Typography'

const Footer: React.FunctionComponent<React.PropsWithChildren> = () => {
  const language = useBookingFormStore((state) => state.language)
  const languageInitialized = useBookingFormStore((state) => state.languageInitialized)
  const step = useBookingFormStore((state) => state.stepper.step)

  const showFooterBackground = step === 1

  return (
    <>
      {languageInitialized && (
        <FooterBackgroundWrapper footerWithBackground={showFooterBackground}>
          <Container component="footer">
            {showFooterBackground && <PriceExplanationDescription />}
            <div className="flex flex-wrap justify-center items-baseline font-medium text-sm text-muted py-6 sm:flex-nowrap sm:justify-between">
              <div className="w-full text-center uppercase flex flex-col items-center space-y-[5px] sm:items-start sm:w-fit sm:text-left">
                <Typography component="div" variant="caption">
                  {new Date().getFullYear()} &copy; {getCopyright()}
                </Typography>
                <Typography component="div" variant="caption">
                  <FormattedMessage
                    defaultMessage="Service provided by SpaBooking s.r.o."
                    description="Description for service provider in footer"
                  />
                </Typography>
              </div>
              <nav className={styles.rootNavigation}>
                <a
                  href={getTermsAndConditionsLink(language)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <FormattedMessage
                    defaultMessage="General Terms & Conditions"
                    description="Footer link for General Terms and Conditions"
                  />
                </a>
                <a
                  href={getPersonalDataProcessingLink(language)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <FormattedMessage
                    defaultMessage="Privacy Policy"
                    description="Footer link for Privacy policy"
                  />
                </a>
                <a href={getContactLink(language)} rel="noopener noreferrer" target="_blank">
                  <FormattedMessage
                    defaultMessage="Contact"
                    description="Footer link for Contact"
                  />
                </a>
              </nav>
            </div>
          </Container>
        </FooterBackgroundWrapper>
      )}
    </>
  )
}

export default Footer
